export const TRY_BASE_PRICE_MINOR = 10_000n;
export const SQLITE_INT64_MAX = 9_223_372_036_854_775_807n;
export const STRIPE_MAX_AMOUNT_MINOR = 99_999_999n;

export type PriceRefusalReason = "BELOW_BASE_PRICE" | "PROVIDER_LIMIT" | "INT64_OVERFLOW";

export type PriceResult =
  | { ok: true; amountMinor: bigint }
  | { ok: false; reason: PriceRefusalReason; attemptedAmountMinor: bigint };

export function validateCheckoutPrice(amountMinor: bigint): PriceResult {
  if (amountMinor < TRY_BASE_PRICE_MINOR) {
    return { ok: false, reason: "BELOW_BASE_PRICE", attemptedAmountMinor: amountMinor };
  }
  if (amountMinor > SQLITE_INT64_MAX) {
    return { ok: false, reason: "INT64_OVERFLOW", attemptedAmountMinor: amountMinor };
  }
  if (amountMinor > STRIPE_MAX_AMOUNT_MINOR) {
    return { ok: false, reason: "PROVIDER_LIMIT", attemptedAmountMinor: amountMinor };
  }
  return { ok: true, amountMinor };
}

export function doubleTryPrice(currentAmountMinor: bigint): PriceResult {
  if (currentAmountMinor > SQLITE_INT64_MAX / 2n) {
    return {
      ok: false,
      reason: "INT64_OVERFLOW",
      attemptedAmountMinor: currentAmountMinor * 2n
    };
  }

  return validateCheckoutPrice(currentAmountMinor * 2n);
}

export function formatTry(amountMinor: bigint, locale = "tr-TR") {
  const safeNumber = Number(amountMinor);
  if (!Number.isSafeInteger(safeNumber)) {
    throw new RangeError("TRY amount cannot be formatted safely as a JavaScript number");
  }
  return new Intl.NumberFormat(locale, { style: "currency", currency: "TRY" }).format(
    safeNumber / 100
  );
}
